import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { NoSidebarPageLayout } from '@insurancemenu/imenu-components-lib';
import { SUBSCRIBER_CARD_DATA } from 'global/checklists-helpers/SubscriberChecklistHelper';
import QuoteSubscriberProfilePageStore, {
  QuoteSubscriberProfilePageStoreContext,
  useQuoteSubscriberProfilePageStore,
} from 'store/pages/subscriber/quote-subscriber-profile/pageStore';
import useSubscriberTaskUrlParams from 'global/hooks/useSubscriberTaskUrlParams';
import QuoteSubscriberProfileForm from 'components/subscriber/quote-subscriber-profile';
import { buildGroupContextMoreInfoBlobProps } from 'components/common/group/GroupContextMoreInfoBlob';
import { buildGroupContactInfoMap } from 'global/services-helpers/groupService';

// TESTING_POLICY: CYPRESS_ONLY

const PageContent: React.FC = observer(() => {
  const { getInitialData, returnBack, isInitialLoading, group } = useQuoteSubscriberProfilePageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <NoSidebarPageLayout
      contentWidth="standard"
      isInitialLoading={isInitialLoading}
      isInfoSectionLoading={isInitialLoading}
      moreInfoBlob={buildGroupContextMoreInfoBlobProps({
        blobTitle: group?.name || '',
        generalInfoMap: { group: group?.name || '' },
        contactInfoMap: buildGroupContactInfoMap(group?.contactInfo ?? null),
      })}
      pageHeader={{
        title: SUBSCRIBER_CARD_DATA.QUOTING_SUBSCRIBER_PROFILE.title,
        subtitle: SUBSCRIBER_CARD_DATA.QUOTING_SUBSCRIBER_PROFILE.text,
        onBackButtonClick: returnBack,
        spacing: 'withBreadcrumbsSection',
      }}
    >
      <QuoteSubscriberProfileForm />
    </NoSidebarPageLayout>
  );
});

const QuoteSubscriberProfilePage: React.FC = () => {
  const { groupId, subscriberId, entityId } = useSubscriberTaskUrlParams();

  const pageStore = useMemo(
    () =>
      new QuoteSubscriberProfilePageStore({
        groupId,
        subscriberId,
        entityId,
      }),
    [],
  );
  return (
    <QuoteSubscriberProfilePageStoreContext.Provider value={pageStore}>
      <PageContent />
    </QuoteSubscriberProfilePageStoreContext.Provider>
  );
};

export default QuoteSubscriberProfilePage;
